import React, { useState, useEffect } from 'react';
import {
  Button,
  Container,
  Box,
  Modal,
  Tooltip,
  Paper,
  TextField,
  Typography
} from '@mui/material';
import { useNavigate, useParams } from 'react-router-dom';

const EditSalaryHeadType = () => {
  const [showSuccessModal, setShowSuccessModal] = useState(false);
  const [salaryHeadTypeName, setSalaryHeadTypeName] = useState('');
  const navigate = useNavigate();
  const { salaryHeadTypeId } = useParams();

  // Static data for salary head types
  const staticSalaryHeadTypeData = [
    { salaryHeadTypeId: 1, salaryHeadTypeName: 'Basic Salary' },
    { salaryHeadTypeId: 2, salaryHeadTypeName: 'Allowances' },
    { salaryHeadTypeId: 3, salaryHeadTypeName: 'Bonuses' },
    { salaryHeadTypeId: 4, salaryHeadTypeName: 'Deductions' },
    { salaryHeadTypeId: 5, salaryHeadTypeName: 'Overtime Pay' },
    { salaryHeadTypeId: 6, salaryHeadTypeName: 'Taxes' },
  ];

  useEffect(() => {
    // Auto-fill the form with the salary head type data based on the salaryHeadTypeId
    const salaryHeadType = staticSalaryHeadTypeData.find(
      (type) => type.salaryHeadTypeId === parseInt(salaryHeadTypeId)
    );
    if (salaryHeadType) {
      setSalaryHeadTypeName(salaryHeadType.salaryHeadTypeName);
    }
  }, [salaryHeadTypeId]);

  const handleSave = (e) => {
    e.preventDefault();
    if (salaryHeadTypeName) {
      setShowSuccessModal(true);
    } else {
      alert('Please fill all fields');
    }
  };

  const handleCancel = () => {
   navigate(-1);
  };

  return (
    <Container>
      <Box
        sx={{
          backgroundColor: 'rgba(2, 78, 101, 1)',
          padding: '12px 16px',
          boxShadow: 3,
          borderRadius: '4px 4px 0 0',
          margin: '0 auto',
          width: "100%",
        }}
      >
        <Typography variant="h4" sx={{ color: '#fff', fontWeight: 'bold' }}>
          Edit Salary Head Type
        </Typography>
      </Box>
      <Paper elevation={3} style={{ padding: 16, width: '100%', margin: 'auto', marginTop: 6, backgroundColor: '#f8fdfeff' }}>
        <div>
          <TextField
            label="Salary Head Type Name"
            variant="outlined"
            fullWidth
            value={salaryHeadTypeName}
            onChange={(e) => setSalaryHeadTypeName(e.target.value)}
            sx={{ my: 2 }}
          />
          <Tooltip title={!salaryHeadTypeName ? "Enter Salary Head Type Name" : ""} arrow>
            <span>
              <Button
                variant="contained"
                onClick={handleSave}
                sx={{
                  mr: 2,
                  backgroundColor: '#127498ff',
                  '&:hover': { backgroundColor: '#116280ff' }
                }}
                disabled={!salaryHeadTypeName}
              >
                SAVE
              </Button>
            </span>
          </Tooltip>
          <Button
            variant="contained"
            color="error"
            onClick={handleCancel}
          >
            CANCEL
          </Button>
        </div>
      </Paper>
      <Modal
        open={showSuccessModal}
        onClose={() => setShowSuccessModal(false)}
        aria-labelledby="success-modal-title"
        aria-describedby="success-modal-description"
      >
        <Box
          sx={{
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            width: 400,
            bgcolor: 'background.paper',
            borderRadius: 2,
            boxShadow: 24,
            overflow: 'hidden',
          }}
        >
          <Box sx={{ backgroundColor: '#0B1F40', padding: '12px 16px' }}>
            <Typography id="success-modal-title" variant="h6" sx={{ color: '#fff' }}>
              Salary Head Type Updated ✅
            </Typography>
          </Box>
          <Box sx={{ padding: '20px' }}>
            <Typography id="success-modal-description" sx={{ mb: 2 }}>
              Salary Head Type Updated Successfully
            </Typography>
            <Box sx={{ display: 'flex', justifyContent: 'flex-end', mt: 3 }}>
              <Button
                onClick={() => {
                  setShowSuccessModal(false);
                  navigate(-1);
                }}
                variant="contained"
                color="primary"
              >
                OK
              </Button>
            </Box>
          </Box>
        </Box>
      </Modal>
    </Container>
  );
};

export default EditSalaryHeadType;
